import { useEffect, useState } from 'react';
import { Card, Col, Form, message, Row, Space, Typography } from 'antd';
import { BookyInput } from '../Components/Forms/BookyInput';
import { BookyButton } from '../Components/Buttons/BookyButton';
import { AdminService } from '../Services/AdminService';
import { SaveOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const AdminIntegrationSettings = () => {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [result, setResult] = useState({} as any);
    const apiBaseUrl = process.env.REACT_APP_API_URL_BASE || '';
    const suggestedCallbackUrl = `${apiBaseUrl}/api/Integration/HandleRefundStatusUpdated`;
    const suggestedDisbursementCallbackUrl = `${apiBaseUrl}/api/Integration/HandleDisbursementCallback`;

    useEffect(() => {
        AdminService.GetTenant().then(result => {
            setResult(result);
            form.setFieldValue("refundCallbackUrl", result.refundCallbackUrl);
            form.setFieldValue("disbursementCallbackUrl", result.disbursementCallbackUrl);
        });
    }, []);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            setSaving(true);
            await AdminService.UpdateTenant({
                refundCallbackUrl: values.refundCallbackUrl || null,
                disbursementCallbackUrl: values.disbursementCallbackUrl || null,
            });
            message.success('Integration settings updated successfully');
        } catch (error) {
            message.error('Failed to update integration settings');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Card>
                    <Title level={4}>Ping Payments Tenant Settings</Title>
                    Tenant id: {result.id}
                    <Paragraph type="secondary">
                        Configure the Ping Payments tenant settings. These settings apply globally to the Ping Payments integration.
                    </Paragraph>
                    <Form
                        form={form}
                        layout="vertical"
                        style={{ maxWidth: 600 }}
                    >
                        <BookyInput
                            label="Refund Callback URL"
                            name="refundCallbackUrl"
                            placeholder={suggestedCallbackUrl}
                        />

                        <BookyInput
                            label="Disbursement Callback URL"
                            name="disbursementCallbackUrl"
                            placeholder={suggestedDisbursementCallbackUrl}
                        />

                        <Form.Item>
                            <Space>
                                <BookyButton
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    text="Save Settings"
                                    onClick={onSave}
                                    loading={saving}
                                />
                            </Space>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

export default AdminIntegrationSettings;
